module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pv"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "sink"
  }, [_c('p', {
    staticClass: "right "
  }, [_c('em', [_vm._v("To all the patriotic Egyptians, Tunisians, and the")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("rest of the Arabs who took over the streets and")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("made history that inspired the world")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "right "
  }, [_c('em', [_vm._v("To every brave man and woman who")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("made the ultimate sacrifice")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "right "
  }, [_c('em', [_vm._v("To future generations, in hopes that they")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("will live in a free and democratic world ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133e2d69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 63
// module chunks = 0